module.exports = __webpack_public_path__ + "img/trend-shape-increase.5b84a775.png";